// @flow

/* eslint-disable ta-code-conventions/has-matching-storydoc, ta-code-conventions/has-matching-test */

import { localize } from '@ta/common.i18n';
import type { Fetcher, FetcherResults } from '../Typeahead';

/** The fetcher ID */
export const ID = 'worldwide';

/**
 * Simple fetcher that only returns one result: 'Worldwide'.
 */
class WorldwideFetcher implements Fetcher {
  id: string = ID;
  results: FetcherResults = null;
  name: string = localize('dual_search_worldwide');

  getResults(): FetcherResults {
    return this.results;
  }

  fetch(term: string, context: ?{ [string]: any }, onChange: () => mixed): void {
    this.results =
      term.length < 3 || this.name.toLowerCase().indexOf(term.toLowerCase()) < 0
        ? null
        : [
            {
              type: 'GEO',
              value: '1',
              displayValue: this.name,
              details: {
                name: this.name,
              },
            },
          ];
    onChange();
  }
}

export default WorldwideFetcher;
